import api from './axios';

export interface PromoBanner {
  id: number;
  title: string;
  titleZh: string | null;
  titleCn: string | null;
  desktopImageUrl: string;
  desktopImageUrlZh: string | null;
  desktopImageUrlCn: string | null;
  mobileImageUrl: string;
  mobileImageUrlZh: string | null;
  mobileImageUrlCn: string | null;
  bannerUrl: string;
  bannerUrlZh: string | null;
  bannerUrlCn: string | null;
  description: string;
  descriptionZh: string | null;
  descriptionCn: string | null;
  promoCode: string;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export const promoBannersApi = {
  getActiveBanners: async (language?: string): Promise<PromoBanner[]> => {
    try {
      const params = language ? { language } : {};
      const response = await api.get('/api/promo-banners/active', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching active promo banners:', error);
      return [];
    }
  },
};
